
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Editor } from '@tiptap/core';
import MenuButton from '@/components/tiptap/Menu/MenuButton.vue';
import { TipTapEditorContext } from '@/components/tiptap/types';

@Component({
  components: {
    MenuButton,
  },
})
export default class MenuBulletListButton extends Vue {
  @Prop({ required: true }) editor: Editor;
  @Prop({ required: true }) editorContext: TipTapEditorContext;
  @Prop({ default: () => {} }) command: () => void;

  get isActive() {
    return this.editorContext.state.isActiveOrderedList;
  }

  runCommand() {
    this.editor.chain().focus().toggleOrderedList().run();
    this?.command();
  }
}
